module.exports = __webpack_public_path__ + "static/media/Icon_menu_recommend_rental_white.e0026b13.svg";